window.addEventListener('DOMContentLoaded', function() {
  (function() {
    let announcementBar = document.querySelector('.announcement-bar')
    let headerBar = document.getElementById('shopify-section-static-header')
    let utilityBar = document.getElementById('shopify-section-static-utility-bar')

    headerBar.style.top = `${announcementBar.offsetHeight}px`
  })()
})

window.addEventListener('load', function() {
  (function() {
    let bodie = document.querySelector('body.template-page')
    if (!bodie) return
    bodie.style.overflowX = `unset!important`
    bodie.style.overflowY = `unset!important`
  })();
})
